import React from 'react';

/** Pick a campus dependent from directory results. */
export default function BookingDependentPick({ dependents, primary, onPick, onManual, onBack }) {
  return (
    <div className="border-t border-white/10 pt-4 mt-4" data-testid="booking-dependent-pick">
      <div className="flex items-center justify-between mb-3">
        <p className="text-[11px] uppercase tracking-wider text-zinc-400">Select dependent</p>
        <button type="button" onClick={onBack} className="text-[11px] text-zinc-500 hover:text-zinc-300">Back</button>
      </div>
      {dependents.length === 0 ? (
        <p className="text-[12px] text-zinc-400 mb-3">No dependents on file for this staff member.</p>
      ) : (
        <div className="space-y-2 mb-3">
          {dependents.map((d) => (
            <button
              key={d.id}
              type="button"
              onClick={() => onPick(d)}
              className="w-full text-left rounded-xl border border-white/12 hover:bg-white/[0.06] px-4 py-3"
              style={{ borderColor: `${primary}55` }}
              data-testid={`booking-dependent-${d.id}`}
            >
              <p className="font-semibold text-zinc-100 text-sm">{d.name}</p>
              <p className="text-[11px] text-zinc-500 mt-0.5 capitalize">{d.relationship}</p>
            </button>
          ))}
        </div>
      )}
      <button
        type="button"
        onClick={onManual}
        className="w-full text-[12px] text-zinc-300 underline underline-offset-2"
        data-testid="booking-dependent-manual"
      >
        Dependent not listed — enter full details
      </button>
    </div>
  );
}
